<template>

  <!--  文件上传组件
  type：格式  img file

  max ：最大上传数量

  -->
  <div style="display: flex;flex-wrap: wrap" id="upload_file">
    <div v-for="(item,index) in uploadFileList" v-if="type=='img'" :key="index" style="position: relative">

      <div class="del-icon-box" v-if="showDelete">
        <i class="el-icon-circle-close del_iocn" @click="delFile(index)"></i>
      </div>

      <el-image
        class="img_list"
        :src="static_path + '/' +item"
        lazy
        :preview-src-list="[static_path + '/' +item]"
        fit="scale-down"
      >
      </el-image>
    </div>

    <div v-for="(item,index) in uploadFileList" v-if="type=='file'" :key="index"
         style="border-radius: 2px;border:solid 1px #CCCCCC;padding:0 3px;margin-left: 5px">
      {{ item }} <i class="el-icon-close" v-if="showDelete" style="cursor: pointer" @click="delFile(index)"></i>

    </div>
    　
    <el-upload
      v-if="show_dom && uploadFileList.length<max"
      action="https://upload-z2.qiniup.com"
      :list-type="type=='img'?'picture-card':'text'"
      :http-request="customerUpload"
      :show-file-list="false"
      style="margin-left: 5px"
      :before-upload="beforeAvatarUpload">

      <i v-if="showDelete" class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>

  </div>
</template>

<script>

import u from "@/assets/js/util"

const qiniu = require('qiniu-js')
export default {
  props: ["type", "max", "values"],
  name: "upload",
  data() {
    return {
      showDelete: true,
      static_path: u.config().static,
      imageUrl: "",
      uploadFileList: [],
      token: "",
      show_dom: true,
    }
  },
  async mounted() {

    if (this.values && this.values.length) {
      setTimeout(() => {
        this.uploadFileList = this.values
        this.updateinof()
        this.$forceUpdate()
      }, 300)
    }
  },
  methods: {
    updateinof() {
      this.uploadFileList = this.values
    },
    edit_data() {
      this.show_dom = true
      this.showDelete = true
    },
    remove_value() {
      this.uploadFileList = []
    },
    setvalue(e) {
      this.show_dom = false
      this.showDelete = false
      if (e && e.length) {
        e.forEach((item) => {
          this.uploadFileList.push(item.replace(this.static_path, ''))
        })
      }
    },
    async customerUpload(request) {

      this.token = await u.post("users", "get_auth_kay", {})
      var _this = this
      const {file} = request;

      if (this.type == 'img') {
        const options = {}

        qiniu.compressImage(file, options).then(data => {

          const observable = qiniu.upload(data.dist, Math.random().toString().substring(2, 8) + "_" + file.name, this.token)
          observable.subscribe((next) => {
          }, (error) => {
          }, (complete) => {

            _this.uploadFileList.push(complete.key)
            this.$emit("upload", _this.uploadFileList)
            if (_this.uploadFileList.length == _this.max) {
              _this.show_dom = false

            }
          })

        })
      } else {
        const observable = qiniu.upload(file, Math.random().toString().substring(2, 8) + "_" + file.name, this.token)
        observable.subscribe((next) => {
        }, (error) => {
        }, (complete) => {
          _this.uploadFileList.push(complete.key)
          this.$emit("upload", _this.uploadFileList)
          if (_this.uploadFileList.length == _this.max) {
            _this.show_dom = false

          }
        })

      }
    },
    async delFile(index) {
      await u.post("users", "del_file", {filename: this.uploadFileList[index]})

      this.$emit("delete", index)
      this.uploadFileList.splice(index, 1)

      this.show_dom = true
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {

      var imgtype = "image/gif,image/jpeg,image/jpg,image/pjpeg,image/x-png,image/png,image/bmp"

      var data = imgtype.split(",")

      var img_status = false
      for (var dataKey in data) {
        if (data[dataKey] == file.type) {
          img_status = true
        }

      }
      if (this.type == 'img' && img_status === false) {

        this.$message.error('文件格式不正确 ');
        return false
      }


      const isLt2M = file.size / 1024 / 1024 < 1000;
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 10MB!');
      // }
      return isLt2M;
    }
  }
}
</script>

<style scoped>

.img_list {
  width: 120px;
  height: 120px;
  padding: 5px;
  border-radius: 5px;
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  box-sizing: border-box;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
  margin-left: 5px;
}

#upload_file >>> .el-upload--picture-card {
  width: 120px;
  height: 120px;
  cursor: pointer;
  line-height: 120px;
  margin-left: 5px;
}

.del-icon-box {
  width: 120px;
  height: 20px;
  position: absolute;
  top: 0;
  left: 5px;
  border-radius: 5px;
  text-align: right;
  /*line-height: 120px;*/
  cursor: pointer;
  z-index: 99;
}

/*.del-icon-box:hover {*/
/*  background-color: #efefef;*/
/*  opacity: 0.5;*/
/*}*/

.del_iocn {
  color: #cccccc;
  font-size: 20px;
}


/*.del-icon-box:hover .del_iocn {*/
/*  display: inline-block;*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/page/module/util/upload.vue